import React from 'react';
import { Switch, Route } from 'react-router';
import { lazyWithRetry } from 'Shared/utils/retry';

// Types
import { Feature } from 'Shared/types/Organization.type';

// Hooks
import { useFeature } from 'Shared/utils/hooks';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
const ThreeSixtyReviewKickoffStartPage = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../ThreeSixtyReviewKickoffStartPage/ThreeSixtyReviewKickoffStartPage')
);
const ThreeSixtyReviewNewPage = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../ThreeSixtyReviewNewPage/ThreeSixtyReviewNewPage')
);
const ThreeSixtySelfReviewNewPage = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../ThreeSixtySelfReviewNewPage/ThreeSixtySelfReviewNewPage')
);
const ThreeSixtyReviewQuestionnairePage = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../ThreeSixtyReviewQuestionnairePage/ThreeSixtyReviewQuestionnairePage')
);
const ThreeSixtyCompilationPage = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../ThreeSixtyCompilationPage/ThreeSixtyCompilationPage')
);
const ThreeSixtySharePage = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../ThreeSixtySharePage/ThreeSixtySharePage')
);

import ThreeSixtyFreePlanBlockerPage from '../ThreeSixtyFreePlanBlockerPage/ThreeSixtyFreePlanBlockerPage';

const ThreeSixtyRouteWrapper = () => {
  const { isFreePlan } = useFeature(Feature.reviews);

  if (isFreePlan) {
    return <ThreeSixtyFreePlanBlockerPage />;
  }
  return (
    <Switch>
      <Route path={PageUrls.COACHING_360_START} component={ThreeSixtyReviewKickoffStartPage} />
      <Route path={PageUrls.COACHING_SELF_360_NEW} component={ThreeSixtySelfReviewNewPage} />
      <Route path={PageUrls.COACHING_360_NEW} component={ThreeSixtyReviewNewPage} />
      <Route path={PageUrls.PEER_REVIEW_FORM} component={ThreeSixtyReviewQuestionnairePage} />
      <Route path={PageUrls.COACHING_360_SHARE} component={ThreeSixtySharePage} />
      <Route path={PageUrls.COACHING_360_COMPILATION} component={ThreeSixtyCompilationPage} />
    </Switch>
  );
};

export default ThreeSixtyRouteWrapper;
